import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { ReactNode } from 'react';

export function ProtectedRoute({ children, allowGuest = false }: { children: ReactNode; allowGuest?: boolean }) {
  const { status } = useAuth();
  const loc = useLocation();
  if (status === 'loading') return <div className="p-8">Loading…</div>;
  if (status === 'anonymous') {
    const redirect = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }
  if (status === 'guest' && !allowGuest) {
    return <Navigate to="/spots" replace />;
  }
  return <>{children}</>;
}
